(function () {
    'use strict';

    angular
        .module('flightPunctuality')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('flightPunctuality', {
                sticky: true,
                url: '/flight-punctuality',
                views: {
                    'flightPunctualityView': {
                        templateUrl: 'flight-punctuality/views/flight-punctuality-new.tpl.html',
                        controller: 'FlightPunctualityCtrl',
                        controllerAs: 'flightPunctuality'
                    }
                }
            });
    }
}());
